import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import useRejectBusinessAccountRequest from '../../hooks/useRejectBusinessAccountRequest';
import {
  initRejectBusinessAccountRequestValues,
  rejectBusinessAccountRequestSchema,
} from '../../schemas/business-account-request.schema';

const useBusinessAccountRequestRejectForm = (id: string, onClose: () => void) => {
  const { control, handleSubmit, reset, watch } = useForm({
    resolver: yupResolver(rejectBusinessAccountRequestSchema),
    defaultValues: initRejectBusinessAccountRequestValues,
  });

  const { mutate, error, isLoading } = useRejectBusinessAccountRequest(id, () => {
    reset(initRejectBusinessAccountRequestValues);
    onClose();
  });

  return {
    control,
    error,
    isLoading,
    rejectionReason: watch('rejectionReason'),
    onSubmit: handleSubmit((values) => {
      mutate(values.rejectionReason);
    }),
  };
};

export default useBusinessAccountRequestRejectForm;
